<template>
    <div class="all">
        <van-nav-bar
                title="教程内容"
                left-text="返回"
                right-text
                left-arrow
                @click-left="$goBack()"
                @click-right
        />
        <div class="body">
            <div v-if="course.courseUrl" style="margin-bottom: 2rem">
                <iframe frameborder="0" :src="course.courseUrl" width="100%" style="min-height: 100rem;">
                </iframe>
            </div>
            <div v-if="course.videoUrl" style="margin-bottom: 2rem">
                <!--<p>视频教程</p>-->
                <video-player ref="videoPlayer" :playsinline="true" :options="playerOptions" style="margin-bottom: 1rem;"></video-player>
                <van-button type="primary" round v-clipboard:copy="course.videoUrl"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError">点此复制链接到浏览器中下载</van-button>
            </div>
            <div v-if="course.imgUrl" style="margin-bottom: 2rem">
                <!--<p>图片教程</p>-->
                <img :src="course.imgUrl" width="100%"/>
            </div>
        </div>
    </div>
</template>

<script>
    import courseAPI from '@/api/course';

    export default {
        data() {
            return {
                query: {
                    courseId: this.$route.query.courseId,
                },
                course: {},
                /**
                 *播放器配置
                 */
                playerOptions : {
                    playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                    autoplay: false, //如果true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 导致视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        src: '',  // 路径
                        type: 'video/mp4'  // 类型
                    }],
                    poster: "", //你的封面地址
                    // width: document.documentElement.clientWidth,
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        fullscreenToggle: true  //全屏按钮
                    }
                }
            }
        },
        created() {
            this.queryCourseDetail();
        },
        methods: {
            queryCourseDetail() {
                this.$toast.loading({forbidClick: true});

                courseAPI.queryCourseDetail(this.query.courseId).then((result) => {
                    this.course = result.data;
                    this.playerOptions.sources[0].src = result.data.videoUrl;
                    this.$toast.clear();
                })
            },
            onError() {
                this.$toast.fail('复制失败')
            },
            onCopy() {
                this.$toast.success('复制成功')
            },
        }
    }
</script>

<style lang="scss">
    .all {
        background-color: #fff;
    }

    .body {
        margin: 3rem 2rem;
        text-align: center;
    }

    .video-js .vjs-big-play-button {
        left: 50% !important;
        top: 50% !important;
        margin-left: -1.5em;
        margin-top: -1em;
    }

</style>